<template>
    <div v-if="images" class="images-gallery-container">
        <div class="images-gallery" ref="images_gallery">
            <swiper
                ref="swiperGallery"
                class="swiper"
                :options="swiper_option"
                @slideChangeTransitionEnd="slideChanged"
            >
                <swiper-slide
                    v-for="(image, index) in images"
                    :key="index"
                >
                    <div
                        v-if="showIcons"
                        :style="{
                            width: local_images[image.id].width + 'px',
                            height: local_images[image.id].height + 'px',
                            margin: 'auto'
                        }"
                    >
                        <img
                            :src="image.url.gallery"
                            :style="{
                                width: local_images[image.id].width + 'px',
                                height: local_images[image.id].height + 'px'
                            }"
                        />

                        <floor-plan-icons
                            v-if="hasIcons && active == index"
                            :floor-plan="local_images[image.id]"
                        />
                    </div>

                    <img
                        v-else
                        class="img-gallery swiper-lazy"
                        :data-src="image.url.gallery"
                    />
                    
                    <div v-if="!showIcons" class="swiper-lazy-preloader"></div>
                </swiper-slide>

                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>

        <div
            v-if="thumb"
            :class="show_thumb ? 'thumb_close_open' : 'thumb_close_closed'"
        >
            <div class="thumb_close">
                {{ active + 1 }} / {{ images.length }}
                {{ show_thumb ? lang.media.thumb_close : lang.media.thumb_open }}
            </div>
            <div
                v-if="show_thumb"
                class="images-gallery-thumb"
            >
                <swiper
                    ref="swiperThumb"
                    class="swiper"
                    :options="swiper_option_thumb"
                >
                    <swiper-slide
                        v-for="(image, index) in images"
                        :key="index"
                        :class="((index) == active) ? 'active' : ''"
                    >
                        <img
                            class="img-gallery-thumb swiper-lazy"
                            :data-src="image.url.gallery_preview"
                            @click="select(index)"
                        />

                        <div class="swiper-lazy-preloader"></div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>

        <modal
            name="plan-gallery"
            ref="plan-gallery"
            extra-class="full-screen plan-gallery"
            v-if="hasIcons"
        >
            <template slot="body" slot-scope="props">
                <img :src="props.data.url.detail" class="plan-gallery-img" />
            </template>
        </modal>

        <modal
            name="plan-virtualtour"
            ref="plan-virtualtour"
            extra-class="full-screen plan-gallery"
            v-if="hasIcons"
        >
            <template slot="body" slot-scope="props">
                <iframe
                    :src="props.data.url"
                    bordersize="0"
                    allowfullscreen="true"
                    allow="vr,gyroscope,accelerometer"
                    class="virtual-tour embed-responsive-item"
                >
                </iframe>
            </template>
        </modal>
    </div>
</template>

<script>
import FloorPlanIcons from './FloorPlanIcons'
import Modal from '../Modal'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    components: {
        'floor-plan-icons': FloorPlanIcons,
        'modal': Modal,
        Swiper,
        SwiperSlide
    },

    props: {
        images: {
            type: Array,
            required: true
        },

        hasIcons: {
            type: Boolean,
            default: false,
        },

        activeIndex: {
            required: false,
        },

        thumb: {
            required: false,
            default: false
        }
    },

    data() {
        return {
            active: 0,
            orientation: this.$root.orientation,
            page: 0,
            local_images: {},
            show_compact: false,
            show_thumb: 1,
            swiper: null,
            swiper_option: {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                keyboard: {
                    enabled: true,
                },
                preloadImages: false,
                lazy: {
                    loadPrevNext: true
                },
                loop: false,
                followFinger: false,
                // allowTouchMove: false,
                mousewheel: {
                    sensitivity: 10,
                    forceToAxis: true
                },
                preventClicks: false,
                preventClicksPropagation: false
            },
            swiper_option_thumb: {
                breakpoints: {
                    4096: {slidesPerView: 20},
                    2560: {slidesPerView: 15},
                    2240: {slidesPerView: 13},
                    1920: {slidesPerView: 11},
                    1600: {slidesPerView: 9},
                    1280: {slidesPerView: 7},
                    1024: {slidesPerView: 6},
                    768: {slidesPerView: 5},
                    640: {slidesPerView: 4},
                    320: {slidesPerView: 3}
                },
                loop: false,
                // followFinger: false,
                // // allowTouchMove: false,
                // mousewheel: {
                //     sensitivity: 10
                // }
                preloadImages: false,
                lazy: {
                    loadPrevNext: true
                },
                preventClicks: false,
                preventClicksPropagation: false
            }
        }
    },

    mounted() {
        this.select(this.activeIndex ?? 0)
        // this.active = this.activeIndex ?? 0
        this.compactMode()
        // if (!this.$root.is_mobile) {
            // this.setCurrentPage(this.activeIndex ?? 0)

            // this.getOriginalImages()

            if (this.hasIcons) {
                this.setLocalImages()

                window.addEventListener('resize', (event) => {
                    this.resizeIcons(event)
                })
            }
        // }
    },

    watch: {
        images() {
            // resetta l'indice active quando viene passato un altro set di immagini
            // es. quando passo da immagini a planimetrie
            this.active = 0
            this.setLocalImages()
        },
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },

        showIcons() {
            return this.hasIcons
                && this.local_images
                && this.local_images[this.images[this.active].id]
               // && window.innerWidth >= 992
        }
    },

    methods: {
        // getOriginalImages() {
        //     this.images.forEach((image, index) => {
        //         this.images[index].url = this.images[index].url.replace('_detail_', '_original_')
        //     })
        // },

        select(key) {
            this.active = key
            this.$refs['swiperGallery'].$swiper.slideTo(key, 1)
            if (this.thumb) {
                this.$refs['swiperThumb'].$swiper.slideTo(key, 500)
            }
        },

        slideChanged() {
            this.active = this.$refs['swiperGallery'].$swiper.activeIndex
            if (this.thumb && this.show_thumb) {
                this.$refs['swiperThumb'].$swiper.slideTo(this.active, 500)
            }
        },

        setLocalImages() {
            this.local_images = {}
            if (this.hasIcons) {
                this.images.forEach(
                    (img) => this.local_images[img.id] = img
                )
                this.resizeIcons()
            }
        },

        resizeIcons() {
            console.log('this.$refs.images_gallery', this.$refs.images_gallery)
            if (typeof this.$refs.images_gallery != 'undefined') {
                let container_width = this.$refs.images_gallery.clientWidth
                let container_height = this.$refs.images_gallery.clientHeight

                Object.entries(this.local_images).forEach(([id, plan]) => {
                    let plan_height_mod = plan.height

                    // Controllo sulla larghezza dell'immagine
                    if (plan.width >= container_width) {
                        // Calcolo la nuova dimensione della planimetria
                        let plan_width_mod = container_width - 30

                        // Calcolo la proporzione per il calcolo delle nuove posizioni delle icone
                        let plan_ratio = (plan_width_mod / plan.width)

                        plan_height_mod = plan.height * plan_ratio

                        // Imposto la nuova dimensione della planimetria
                        plan.width = plan_width_mod
                        plan.height = plan_height_mod
                        
                        if (plan.ico) {
                            plan.ico.forEach((icon) => {
                                icon.y = icon.y * plan_ratio
                                icon.x = icon.x * plan_ratio
                            })
                        }
                    }

                    let max_height = window.innerHeight * 0.6

                    if (plan_height_mod > max_height) {
                        // Calcolo la nuova dimensione della planimetria
                        plan_height_mod = max_height - 30

                        // Calcolo la proporzione per il calcolo delle nuove posizioni delle icone
                        let plan_ratio = (plan_height_mod / plan.height)

                        // Imposto la nuova dimensione della planimetria
                        plan.width = plan.width * plan_ratio
                        plan.height = plan_height_mod

                        if (plan.ico) {
                            plan.ico.forEach((icon) => {
                                icon.y = icon.y * plan_ratio
                                icon.x = icon.x * plan_ratio
                            })
                        }
                    }
                })
            }
        },

        compactMode() {
            this.show_compact = false // this.$root.is_mobile && window.innerWidth >= 992
        }
    }
}
</script>

<style lang="sass" scoped>
    .images-gallery
        .swiper
            height: 1000px

    .gallery_standalone
        .images-gallery
            .swiper
                height: 500px

    .images-gallery-thumb
        margin-top: 25px

        .swiper
            height: 100px

            img.img-gallery-thumb
                width: auto
                height: auto
                max-width: 100%
                max-height: 100%
                transform: translate(-50%, -50%)
                position: absolute
                left: 50%
                top: 50%
                cursor: pointer

            .active
                border: 1px solid #000

    .swiper-slide
        text-align: center
        // background: #444 !important
        img.img-gallery
            width: auto
            height: auto
            max-width: 100%
            max-height: 100%
            transform: translate(-50%, -50%)
            position: absolute
            left: 50%
            top: 50%
            cursor: grab
</style>